import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";

// Discord から /OAuthCallback?code=... で戻るケースを HashRouter 形式へ揃える
if (window.location.pathname === "/OAuthCallback" && window.location.search) {
  window.location.replace(`${window.location.origin}/#/OAuthCallback${window.location.search}`);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
